module.exports = __webpack_public_path__ + "static/media/icon-brand-recognition.74a6ae69.svg";